import { useGetOS } from './useGetOS';

export const useGetOSMetaKey = () => {
  const os = useGetOS();

  return os === 'macOS' ? '⌘' : 'Ctrl';
};
